var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-group"},[_c('label'),_c('span',[_vm._v(_vm._s(_vm.$translate.text('general.original') + ': ' + _vm.placeholder))])])}
var staticRenderFns = []

export { render, staticRenderFns }